import {useFormikContext} from "formik";
import React, {useEffect} from "react";

export const ChangeDirtyForm = ({changeDirtyAction}) => {
    const formik = useFormikContext();

    useEffect(() => {
        if (!formik.dirty) {
            changeDirtyAction()
        }
    }, [formik.dirty])

    return <></>
}